// @flow
import React from 'react';
import styled, { type StyledComponent, css } from 'styled-components';

import { DSTokenMap, MQ } from '@rover/kibble/styles';
import type { CreditCardSummary, PaymentProvider } from '@rover/react-lib/types/CreditCard';

import RadioRows from '../../../formFields/RadioRows';
import CreditCardIcon from '../../../typography/CreditCardIcon';

const V_CENTER = css`
  display: flex;
  align-items: center;
`;

const MOBILE_FULL_WIDTH = css`
  ${MQ.XS} {
    width: 100%;
    text-align: left;
  }
`;

const CardName: StyledComponent<{}> = styled.div`
  ${V_CENTER} width: 40%;
  ${MOBILE_FULL_WIDTH};

  ${MQ.XS_DOWN} {
    /* targets CreditCardIcon component */
    span {
      display: none;
    }
  }
`;

const CardHolder: StyledComponent<{}> = styled.div`
  width: 45%;
  ${MOBILE_FULL_WIDTH};
`;

const CardExpiration: StyledComponent<{}> = styled.div`
  color: ${DSTokenMap.TEXT_COLOR_TERTIARY};
  width: 15%;
  ${MOBILE_FULL_WIDTH};
`;

const renderCard = (card: CreditCardSummary) => [
  <CardName key="cc-name">
    <CreditCardIcon type={card.cardType} />
    {card.cardType} - {card.lastFour}
  </CardName>,
  <CardHolder key="cc-holder">{card.cardholderName}</CardHolder>,
  <CardExpiration key="cc-exp">
    {card.expirationMonth} / {card.expirationYear}
  </CardExpiration>,
];

const shouldEnableCardEditing = (card: CreditCardSummary, isUpdatable: boolean): boolean => {
  const stripeIndicator: PaymentProvider = 'stripe';
  return isUpdatable && card.paymentProvider === stripeIndicator;
};

export type Props = {
  cards: Array<CreditCardSummary>,
  radioName: string,
  value: string,
  isUpdatable: boolean,
  onChange: (string) => void,
  onDelete: (string) => void,
  onEdit: (CreditCardSummary) => void,
};

const CreditCardOptions = ({
  cards,
  radioName,
  value,
  isUpdatable,
  onChange,
  onEdit,
  onDelete,
}: Props) => (
  <RadioRows
    options={cards.map((card) => ({
      value: card.url,
      editValue: card,
      children: renderCard(card),
      disableDelete: card.defaultPayment,
      isUpdatableElement: shouldEnableCardEditing(card, isUpdatable),
    }))}
    value={value}
    name={radioName}
    isUpdatable={isUpdatable}
    onDelete={onDelete}
    onEdit={onEdit}
    onChange={onChange}
    radioProps={{
      sensitive: true,
    }}
    data-qa-id="credit-card-radios-card"
  />
);

CreditCardOptions.defaultProps = {
  value: '',
  radioName: 'cc',
};

export default CreditCardOptions;



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/CreditCardForm/CreditCardOptions/CreditCardOptions.jsx